import React from "react";

function Discord() {
  return (
    <iframe
      title="Discord Widget"
      src="https://discord.com/widget?id=918599540762890272&theme=dark"
      width="100%"
      height="100%"
      allowtransparency="true"
      frameborder="0"
      sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts"
    />
  );
}

export default Discord;

